"use strict";
"use es6";

/**
 * Merges the provided objects shallowly and removes
 * all properties with an `undefined` value
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compact = compact;
function compact() {
  var objects = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    objects[_i] = arguments[_i];
  }
  var result = Object.create(null);
  objects.forEach(function (obj) {
    if (!obj) return;
    Object.keys(obj).forEach(function (key) {
      var value = obj[key];
      if (value !== void 0) {
        result[key] = value;
      }
    });
  });
  return result;
}